"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CodeMirror = require("codemirror");
var maketypes_1 = require("maketypes");
var file_saver_1 = require("file-saver");
var Clipboard = require("clipboard");
require('codemirror/mode/javascript/javascript');
function createDiagnosticError(cm, pos, msg) {
    var errorDiv = document.createElement('div');
    // <a href="#" data-toggle="tooltip" title="Some tooltip text!">Hover over me</a>
    var glyphiconDiv = document.createElement('span');
    glyphiconDiv.classList.add('glyphicon', 'glyphicon-remove-sign');
    var tooltipAnchor = document.createElement('a');
    tooltipAnchor.setAttribute('data-toggle', 'tooltip');
    // Place over editor so it can be seen.
    tooltipAnchor.setAttribute('data-placement', 'top');
    tooltipAnchor.setAttribute('title', msg);
    tooltipAnchor.setAttribute('data-container', 'body');
    tooltipAnchor.appendChild(glyphiconDiv);
    errorDiv.appendChild(tooltipAnchor);
    var line;
    if (typeof (pos) === 'number') {
        line = cm.getDoc().posFromIndex(pos).line;
    }
    else {
        line = pos.row;
    }
    cm.setGutterMarker(line, "error-gutter", errorDiv);
    $(tooltipAnchor).tooltip();
}
function clearErrorGutter(cm) {
    cm.clearGutter("error-gutter");
}
function saveToFile(cm, filename) {
    var txt = cm.getValue();
    var blob = new Blob([txt], { type: "text/plain;charset=utf-8" });
    file_saver_1.saveAs(blob, filename);
}
var generateBtn = document.getElementById('generate-btn');
var nameInput = document.getElementById('type-name');
var saveInterfaceBtn = document.getElementById('save-interface-btn');
var saveProxyBtn = document.getElementById('save-proxy-btn');
function getRootName() {
    var val = nameInput.value.replace(/ /g, "");
    if (val.length > 0) {
        return val;
    }
    return "Root";
}
var jsonEditor = CodeMirror.fromTextArea(document.getElementById('json-examples'), {
    lineNumbers: true,
    mode: "application/json",
    readOnly: false,
    gutters: ['error-gutter'],
    viewportMargin: 20
});
jsonEditor.setSize("100%", 620);
var tsInterface = CodeMirror.fromTextArea(document.getElementById('ts-interfaces'), {
    lineNumbers: true,
    mode: "text/typescript",
    readOnly: 'nocursor',
    viewportMargin: 10
});
var tsProxy = CodeMirror.fromTextArea(document.getElementById('ts-proxies'), {
    lineNumbers: true,
    mode: "text/typescript",
    readOnly: 'nocursor',
    viewportMargin: 10
});
new Clipboard('#copy-interface-btn', {
    text: function (trigger) {
        return tsInterface.getDoc().getValue();
    }
});
new Clipboard('#copy-proxy-btn', {
    text: function (trigger) {
        return tsProxy.getDoc().getValue();
    }
});
saveInterfaceBtn.addEventListener('click', function () {
    saveToFile(tsInterface, getRootName() + ".d.ts");
});
saveProxyBtn.addEventListener('click', function () {
    saveToFile(tsProxy, getRootName() + ".ts");
});
generateBtn.addEventListener('click', function () {
    clearErrorGutter(jsonEditor);
    tsInterface.setValue("");
    tsProxy.setValue("");
    var jsonTxt = jsonEditor.getDoc().getValue();
    var jsonObj;
    try {
        jsonObj = JSON.parse(jsonTxt);
    }
    catch (e) {
        var err = e;
        // Invalid JSON. Given example '[1, 2, 3,\n 4,]', browsers display the following:
        // Chrome:
        // SyntaxError: Unexpected token ] in JSON at position 13
        // Firefox:
        // SyntaxError: JSON.parse: unexpected character at line 2 column 4 of the JSON data
        // Safari:
        // SyntaxError: JSON Parse error: Unexpected comma at the end of array expression
        // Error gutter.
        var msg = err.message;
        var posIdx = msg.indexOf('position');
        var pos = void 0;
        if (posIdx !== -1) {
            // Chrome.
            pos = parseInt(msg.slice(posIdx + 9), 10);
        }
        else {
            var lineIdx = msg.indexOf('line');
            if (lineIdx !== -1) {
                // Firefox
                var line = parseInt(msg.slice(lineIdx + 5), 10) - 1;
                var colIdx = msg.indexOf('column');
                var col = parseInt(msg.slice(colIdx + 7), 10) - 1;
                pos = { row: line, col: col };
            }
            else {
                // Safari or other.
                pos = 0;
            }
        }
        createDiagnosticError(jsonEditor, pos, msg);
        return;
    }
    var proxy = "";
    var proxyWriter = new maketypes_1.CbWriter(function (s) {
        proxy += s;
    }, function () { });
    var iface = "";
    var ifaceWriter = new maketypes_1.CbWriter(function (s) {
        iface += s;
    }, function () { });
    var emitter = new maketypes_1.Emitter(ifaceWriter, proxyWriter);
    try {
        emitter.emit(jsonObj, getRootName());
    }
    catch (e) {
        createDiagnosticError(jsonEditor, 0, "" + e);
        return;
    }
    tsInterface.setValue(iface);
    tsProxy.setValue(proxy);
});
var weatherSample = "{\n  \"coord\": {\n    \"lon\": 14.42,\n    \"lat\": 50.09\n  },\n  \"weather\": [\n    {\n      \"id\": 802,\n      \"main\": \"Clouds\",\n      \"description\": \"scattered clouds\",\n      \"icon\": \"03d\"\n    }\n  ],\n  \"base\": \"cmc stations\",\n  \"main\": {\n    \"temp\": 5,\n    \"pressure\": 1010,\n    \"humidity\": 100,\n    \"temp_min\": 5,\n    \"temp_max\": 5\n  },\n  \"wind\": { \"speed\": 1.5, \"deg\": 150 },\n  \"clouds\": { \"all\": 32 },\n  \"dt\": 1460700000,\n  \"sys\": {\n    \"type\": 1,\n    \"id\": 5889,\n    \"message\": 0.0033,\n    \"country\": \"CZ\",\n    \"sunrise\": 1460693287,\n    \"sunset\": 1460743037\n  },\n  \"id\": 3067696,\n  \"name\": \"Prague\",\n  \"cod\": 200\n}";
jsonEditor.setValue(weatherSample);
nameInput.value = "Weather";
generateBtn.click();
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./js/index.js
// module id = 0
// module chunks = 0